import gsap from 'gsap/gsap-core';
import {Draggable} from 'gsap/Draggable';
import helpers from '../helpers';
import mapPopup from './map-popup';

gsap.registerPlugin(Draggable);

let draggable;

export let startPositions = {};
// после всех манипуляций финально пройдёмся по сцене и проверим не выходит ли она за пределы
function updateTransform($scene, duration = 0) {
	const data = $scene.get(0).getBoundingClientRect();

	if (data.left >= 0) {
		gsap.to($scene, {
			duration,
			x: `-=${data.left}`,
		});
	}

	if (data.right <= window.innerWidth) {
		gsap.to($scene, {
			duration,
			x: `+=${window.innerWidth - data.right}`,
		});
	}

	if (data.top >= 0) {
		gsap.to($scene, {
			duration,
			y: `0`,
		});
	}
	//
	// if (data.bottom <= window.innerHeight) {
	// 	gsap.to($scene, {
	// 		duration,
	// 		y: `+=${window.innerHeight - data.bottom}`,
	// 	});
	// }
}

function sceneScale($scene, $element, update = true) {
	const isScaleDown = $scene.get(0).getBoundingClientRect().width > $scene.get(0).clientWidth * helpers.zoom;

	// console.log(helpers.zoom, helpers.zoomMin, helpers.zoom === helpers.zoomMin);
	// if (helpers.zoom === helpers.zoomMin) {
	// 	helpers.zoom = 1;
	// }

	return new Promise((resolve) => {
		gsap.to($scene, {
			'scale': helpers.zoom,
			'--zoom-scale': helpers.zoomScale,
			'--scale': helpers.zoom,
			onStart() {
				$($element).attr('disabled', true);
				if ($('.js-popup').hasClass('is-active')) {
					mapPopup.closePopup($('.js-popup.is-active'));
				}
			},
			onUpdate() {
				if (isScaleDown && update) {
					updateTransform($scene);
				}
			},
			onComplete() {
				$($element).attr('disabled', false);

				if (update) {
					updateTransform($scene, 0.3);
				}

				// исправляет баг при котроом иконки мылились после скейла
				gsap.to(['.map__point', '.map__media .image'], {
					scale: 1.0001,
					clearProps: 'transform',
				});

				resolve();
			},
		});
	});
}

function init() {
	const $map = $('.map__container');
	const step = 0.2;
	// активируем драг
	draggable = Draggable.create($map, {
		// type: 'x',
		bounds: '.map',
		zIndexBoost: false,
		dragClickables: true,
		userSelect: 'pointer',
		activeCursor: 'grabbing',
		allowEventDefault: true,
		onPress() {
			if ($('.js-popup').hasClass('is-active')) {
				mapPopup.closePopup($('.js-popup.is-active'));
			}

			startPositions = {
				x: this.x,
				y: this.y,
			};
		},
	});

	// if (!helpers.isMobile()) {
	// 	console.log(draggable.vars);
	// 	draggable.type = 'x, y';
	// 	draggable.update();
	// 	console.log(draggable.vars);
	// }

	// исправляет отображение карты при загрузке
	// https://docs.google.com/document/d/1MSGQ1_dfYiELIjPe4xkOHAUGCLNZ7fpJ47hsApZStF8/edit?pli=1
	setTimeout(() => {
		$('#map').removeClass('is-hide');
	}, 200);

	$('.js-zoom-plus').on('click.zoomer', (e) => {
		$(e.currentTarget).addClass('is-disabled');

		if (helpers.zoom <= helpers.zoomMax) {
			helpers.zoom += step;
			helpers.zoomScale -= step;
			$('.js-zoom-minus').removeClass('is-disabled');

			if (helpers.zoom < helpers.zoomMax) {
				$(e.currentTarget).removeClass('is-disabled');
			}

			sceneScale($map, $(e.currentTarget), draggable);
		}
	});

	$('.js-zoom-minus').on('click.zoomer', (e) => {
		$(e.currentTarget).addClass('is-disabled');

		if (helpers.zoom - step >= helpers.zoomMin) {
			helpers.zoom -= step;
			helpers.zoomScale += step;
			$('.js-zoom-plus').removeClass('is-disabled');

			if (helpers.zoom - step >= helpers.zoomMin) {
				$(e.currentTarget).removeClass('is-disabled');
			}

			sceneScale($map, $(e.currentTarget), draggable);
		}
	});

	helpers.$body.on('keydown.zoomer', (event) => {
		if (event.which === 187 || event.which === 107) {
			if (helpers.zoom <= helpers.zoomMax && !$map.attr('disabled')) {
				$('.js-zoom-plus').addClass('is-disabled');
				$('.js-zoom-minus').removeClass('is-disabled');

				helpers.zoom += step;
				helpers.zoomScale -= step;

				if (helpers.zoom < helpers.zoomMax) {
					$('.js-zoom-plus').removeClass('is-disabled');
				}

				sceneScale($map, $map, draggable);
			}
		}

		if (event.which === 189 || event.which === 109) {
			if (helpers.zoom - step >= helpers.zoomMin && !$map.attr('disabled')) {
				$('.js-zoom-minus').addClass('is-disabled');
				$('.js-zoom-plus').removeClass('is-disabled');

				helpers.zoom -= step;
				helpers.zoomScale += step;

				if (helpers.zoom - step >= helpers.zoomMin) {
					$('.js-zoom-minus').removeClass('is-disabled');
				}

				sceneScale($map, $map, draggable);
			}
		}
	});
}

function destroy() {
	helpers.$body.off('.zoomer');
	$('.js-zoom-plus').off('.zoomer');
	$('.js-zoom-minus').off('.zoomer');
}

export default {
	init,
	destroy,
	sceneScale,
};
